import numberRenders from 'bundles/teach-course-shared/lib/numberRenders';

import _t from 'i18n!nls/video-logged-out-page';

const extractItemSlugAndId = (itemSlugAndIdString: string): Array<string> | null => {
  // itemSlugAndIdString is in the format of `itemSlug-itemId`
  const paramRegex = /(.*)-(\w+)/;
  const regexMatch = itemSlugAndIdString?.match(paramRegex);
  return regexMatch && regexMatch.slice(1, 3);
};

const getEnrollmentText = (courseEnrollmentCount: number, shouldCapitalizeAbbreviation = false): string => {
  if (typeof courseEnrollmentCount === 'undefined') {
    return '';
  }

  const formattedEnrollmentCount = numberRenders.Formatters.largeNumber(
    courseEnrollmentCount,
    shouldCapitalizeAbbreviation
  );

  return formattedEnrollmentCount
    ? _t('#{formattedEnrollmentCount} Students Enrolled', { formattedEnrollmentCount })
    : '';
};

const constructFallBackDescriptionForVlp = (videoTranscript: string) => {
  let trimmedDescription = '';

  const numberOfCharactersInDescription = 100;

  if (videoTranscript.length > trimmedDescription.length) {
    trimmedDescription = videoTranscript.substr(0, numberOfCharactersInDescription);

    trimmedDescription = trimmedDescription.substr(
      0,
      Math.min(trimmedDescription.length, trimmedDescription.lastIndexOf(' '))
    );
  }

  const fallBackMetaDescription = trimmedDescription;

  return fallBackMetaDescription + ' ...';
};

export { extractItemSlugAndId, getEnrollmentText, constructFallBackDescriptionForVlp };
